import { render } from "./PostCategoryFormView.vue?vue&type=template&id=a88855ae&scoped=true"
import script from "./PostCategoryFormView.vue?vue&type=script&lang=js"
export * from "./PostCategoryFormView.vue?vue&type=script&lang=js"

import "./PostCategoryFormView.vue?vue&type=style&index=0&id=a88855ae&lang=less&scoped=true"

import exportComponent from "/home/rampa/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a88855ae"]])

export default __exports__